const checkPhoneForEdit = (phoneNumber) => {
  if (phoneNumber && phoneNumber.includes('-')) {
    const arrPhone = phoneNumber.split('-');
    return arrPhone[1];
  } else {
    return phoneNumber;
  }
}

export default checkPhoneForEdit;